import React from 'react';
import Modal from '@mui/material/Modal';
import {
    MainContainer,
    ContentBody,
    HeaderContainer,
    HeaderCloseButton,
    HeaderCloseIcon,
} from './Modal.styles';
const MyModal = (props) => {
    const { children, visible, onClose, width } = props;

    return (
        <Modal {...props} open={visible}>
            <MainContainer width={width}>
                <HeaderContainer>
                    <HeaderCloseButton onClick={onClose}>
                        <HeaderCloseIcon size={20} />
                    </HeaderCloseButton>
                </HeaderContainer>
                <ContentBody>{children}</ContentBody>
            </MainContainer>
        </Modal>
    );
};

export default MyModal;
